export default {
	contact_data(state) {
		return state.contact_data
	},
}
